import React from 'react';
import VertexSelectionDialog from './VertexSelectionDialog';
import LabelInput from '../Inputs/LabelInput';
import HCLTreeVertex from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertex';
import Label, {LabelJSON} from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label';

interface Props {
  vertex: HCLTreeVertex;
  onClose: () => void;
  onSave: () => void;
}

interface State {
  label: LabelJSON;
  labelError: boolean;
}

class SimpleVertexSelectionDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { vertex } = this.props;
    const value = vertex.getValue();

    this.state = {
      label: value.getLabel().toJSON(),
      labelError: false
    };
  }

  private handleSave = () => {
    const { vertex, onSave } = this.props;
    const { label } = this.state;
    const value = vertex.getValue();
    value.setLabel(Label.build(label));

    onSave();
  };

  /**
   * handle input change of text fields
   * @param {Object} e - event object
   * @param {string} key - This tells us which text field the event is coming from.
   *  Specified by name field of {@link LabelInput}
   */
  private handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, key: string) => {
    e.persist();
    // @ts-ignore
    this.setState(state => ({
      [key]: {
        // @ts-ignore
        ...state[key],
        [e.target.name]: e.target.value,
      },
    }));
  };

  private handleLabelError = (error: boolean) => {
    this.setState({ labelError: error });
  };


  render() {
    const { vertex, onClose } = this.props;
    const { label, labelError } = this.state;

    return (
      <VertexSelectionDialog
        vertex={vertex}
        onClose={onClose}
        onSave={this.handleSave}
        error={labelError}
        open
        maxWidth="xs"
        fullWidth
      >
        <LabelInput
          label={Label.build(label)}
          onChange={this.handleChange}
          name="label"
          onError={this.handleLabelError}
          gridItemProps={{
            xs: 12,
          }}
        />
      </VertexSelectionDialog>
    );
  }
}

export default SimpleVertexSelectionDialog;
